import type { EmailDebugDetails } from "@/lib/emailDebug";

type EmailDebugPanelProps = {
  debug?: EmailDebugDetails;
};

const formatJson = (value: unknown) => {
  if (value === undefined || value === null || value === "") return "Not available";
  if (typeof value === "string") {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  }
  return JSON.stringify(value, null, 2);
};

const EmailDebugPanel = ({ debug }: EmailDebugPanelProps) => {
  if (!debug) return null;

  return (
    <div className="mt-4 rounded-md border border-border bg-muted/40 p-3 text-left text-xs text-foreground" dir="ltr">
      <p className="mb-2 font-semibold">Email delivery debug</p>
      <div className="grid gap-2 sm:grid-cols-2">
        <div>
          <span className="font-medium">Edge status:</span> {debug.edgeStatusCode ?? "Not available"}
        </div>
        <div>
          <span className="font-medium">Resend status:</span>{" "}
          {debug.resendStatusCode ?? "Not available"}
          {debug.resendStatusText ? ` ${debug.resendStatusText}` : ""}
        </div>
      </div>
      <div className="mt-3 space-y-2">
        <div>
          <p className="mb-1 font-medium">Resend response body</p>
          <pre className="max-h-48 overflow-auto rounded bg-background p-2 whitespace-pre-wrap break-words">
            {formatJson(debug.resendResponseBody)}
          </pre>
        </div>
        <div>
          <p className="mb-1 font-medium">Request payload</p>
          <pre className="max-h-64 overflow-auto rounded bg-background p-2 whitespace-pre-wrap break-words">
            {formatJson(debug.requestPayload)}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default EmailDebugPanel;